import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, obj = user

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data.user)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data.user);
    return r.data.user;
  };
  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    setUser(r.data.user);
    return r.data.user;
  };
  const registerBusiness = async (payload) => {
    const r = await api.post("/business/register", payload);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, register, registerBusiness, logout }}>{children}</AuthCtx.Provider>;
}

export const homeForRole = (role) =>
  ({ guest: "/customer", staff: "/staff", manager: "/staff", reception: "/reception", admin: "/admin", superadmin: "/platform" }[role] || "/");

const DEPT_ROUTE = { kitchen: "/kitchen", "food & beverage": "/food-beverage", housekeeping: "/housekeeping", maintenance: "/maintenance", events: "/events" };
export const portalForUser = (user) => {
  if (!user) return "/";
  const byRole = { guest: "/customer", reception: "/reception", admin: "/admin", superadmin: "/platform" };
  if (byRole[user.role]) return byRole[user.role];
  // staff / manager → department-specific portal when available
  return DEPT_ROUTE[(user.department_name || "").toLowerCase()] || "/staff";
};
